import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { UserService } from '@core/services/user.service';
import { RouterModule } from '@angular/router';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';

@Component({
	selector: 'kwo-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
	standalone: true,
	imports: [CommonModule, RouterModule, SearchInputComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent implements OnInit {

	userService = inject(UserService);

	showDiscounts: boolean = false;

	ngOnInit(): void {

		this.showDiscounts = this.userService.getUser() == null;
	}

}
